import { message, Tooltip } from 'antd';
import { DateTime } from 'luxon';
import moment from 'moment';
import React, { createRef, useEffect, useState } from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import { CloudDownload, Pencil, Trash } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { reactFormatter } from 'react-tabulator';
import { deletePaymentService, downloadCreditNoteService, getOrderPaymentsService, getOrderService } from '../../../api/Payments';
import Loader from '../../../common-components/loader';
import constants from '../../../constants';
import Order from '../../../Model/models/orderModel';
import OrderPayment from '../../../Model/Payment';
import TableView from '../../tableView';
import CreditNoteForm from './CreditNoteForm';
import PaymentForm from './PaymentForm';
import './Payments.scss';
import authAxios from '../../../authorization/axios';


function PaymentActions(context: any) {
  // eslint-disable-next-line no-underscore-dangle
  const cellData = context.cell._cell.row.data;
  return <>
    <Tooltip title={context.props.t('EDIT_PAYMENT')}>
      <Button onClick={() => {
        // eslint-disable-next-line no-underscore-dangle
        context.props.editPayments(cellData);
      }} size='sm' style={{ marginRight: '1em', background: 'green', borderColor: 'green' }} color='success'>
        <Pencil />
      </Button>
    </Tooltip>
    <Tooltip title={context.props.t('DELETE_PAYMENT')}>
      <Button onClick={() => {
        // eslint-disable-next-line no-underscore-dangle
        context.props.deletePayments(cellData);
      }} size='sm' style={{ marginRight: '1em', background: 'red', borderColor: 'red' }} color='danger'
        disabled={cellData.billingCode}
      >
        <Trash />
      </Button>
    </Tooltip>
    <Tooltip title={context.props.t('DOWNLOAD_INVOICE')}>
      <Button
        onClick={() => {
          // eslint-disable-next-line no-underscore-dangle
          context.props.downloadInvoice(cellData);
        }}
        size='sm'
        style={{ marginRight: '1em' }}
        disabled={!cellData.billingCode}
      >
        <CloudDownload />
      </Button>
    </Tooltip>
  </>;
}

function CreditNoteActions(context: any) {
  // eslint-disable-next-line no-underscore-dangle
  const cellData = context.cell._cell.row.data;
  return <>
    {/* <Tooltip title={context.props.t('EDIT_PAYMENT')}>
            <Button onClick={() => {
              // eslint-disable-next-line no-underscore-dangle
              context.props.editCreditNotes(cellData);
            }} size='sm' style={{ marginRight: '1em', background: 'green', borderColor: 'green' }} color='success'>
                <Pencil />
            </Button>
        </Tooltip> */}
    <Tooltip title={context.props.t('DOWNLOAD_CREDIT_NOTE')}>
      <Button onClick={() => {
        // eslint-disable-next-line no-underscore-dangle
        context.props.downloadCreditNote(cellData);
      }} size='sm' style={{ marginRight: '1em' }} color='success'>
        <CloudDownload />
      </Button>
    </Tooltip>
  </>;
}

const Payments = () => {
  const [showInvoceModal, setShowInvoiceModal] = useState(false);
  const [showCreditNoteModal, setShowCreditModal] = useState(false);
  const [rowData, setRowData] = useState({});
  const [canEmitFullInvoice, setCanEmitFullInvoice] = useState(false);
  const [canAddPayment, setCanAddPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState<Order>();
  const [payments, setPayments] = useState<OrderPayment[]>();
  const [full, setFull] = useState<any>(false);
  const paymentsTable = createRef<TableView>();
  const creditNotesTable = createRef<TableView>();

  let params: any = useParams();
  let history = useHistory();

  const { t } = useTranslation();


  const getOrder = async (orderId: number) => {
    try {
      const result = await getOrderService(orderId);
      if (result.data) {
        return result.data.data;
      }
      return undefined;
    } catch (error) {
      console.log(error);
    }
  };

  const getOrderPayments = async () => {
    try {
      const result = await getOrderPaymentsService(params.orderId);
      if (result.data) {
        return result.data;
      }
      return [];
    } catch (error) {
      console.log(error);
    }
  };

  const checkPayments = async () => {
    const paymentsOrder = (await getOrderPayments())?.data;
    // if (payments) {
    const fullInvoice = paymentsOrder.find((p: any) => p.isFullBilling);
    const billingProgress = paymentsOrder.map((p: any) => p.percentage).reduce((a: any, b: any) => a + b, 0);
    setCanEmitFullInvoice(fullInvoice === undefined);
    setCanAddPayment(billingProgress >= 100);
    setPayments(paymentsOrder);
    // }
  };

  const getData = async () => {
    const orderById = await getOrder(params.orderId);
    setOrder(orderById);
    await checkPayments();
  };

  useEffect(() => {
    getData();
  }, []);

  const editPayments = (rowDataPayment: any) => {
    setRowData(rowDataPayment);
    setShowInvoiceModal(true);
  };

  const deletePayments = async (rowDataOrderPayment: OrderPayment) => {
    setLoading(true);
    if (rowDataOrderPayment.billingCode) {
      setLoading(false);
      message.error({
        content: t('BILLING_CODE_EMITTED'),
        style: {
          marginTop: 100,
          zIndex: 1100
        }
      });
      return;
    }
    try {
      const result = await deletePaymentService(`${rowDataOrderPayment.id}`);
      if (result) {
        setLoading(false);
      }
      if (result.data.success) {
        paymentsTable.current?.reloadData();
        message.success({
          content: t('PAYMENT_DELETED'),
          style: {
            marginTop: 100,
            zIndex: 1100
          }
        });
        checkPayments().then(() => { });
      }
    } catch (err: any) {
      setLoading(false);
      message.error({
        content: err?.response?.data?.errorMessage ? err?.response?.data?.errorMessage : err.message,
        style: {
          marginTop: 100,
          zIndex: 1100
        }
      });
    }
  };

  const editCreditNotes = (rowDataCredit: any) => {
    history.push({
      pathname: `/orders/${params.orderId}/creditNotes/${rowDataCredit.id}`
    });
  };

  const downloadInvoice = async (rowDataInvoice: any) => {
    setLoading(true);
    authAxios.get(constants.api.dowloadPaymentInvoice.replace('{paymentId}', `${rowDataInvoice.id}`))
      .then((res: any) => {
        if (res.data?.success) {
          // window.open(`data:${res.data.data.mime};base64,${res.data.data.base64}`, '_blank');
          const a = document.createElement('a');
          a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
          a.download = res.data.data.filename;
          a.click();
        }
        setLoading(false);
      }).catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  const downloadCreditNote = async (rowDataCredit: any) => {
    setLoading(true);

    try {
      const res = await downloadCreditNoteService(`${rowDataCredit.id}`);
      if (res.data?.success) {
        // window.open(`data:${res.data.data.mime};base64,${res.data.data.base64}`, '_blank');
        const a = document.createElement('a');
        a.href = `data:${res.data.data.mime};base64,${res.data.data.base64}`;
        a.download = res.data.data.filename;
        a.click();
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const columnsPayments = [
    {
      title: t('DATE'), field: 'date', sorter: 'string', headerFilter: 'input',
      formatter: (cell: any) => {
        const locale = (window.navigator as any).userLanguage || window.navigator.language;
        return moment(cell.getValue()).locale(locale).format('DD/MM/YYYY HH:mm');
      }
    },
    {
      title: t('AMOUNT'),
      field: 'amount',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('PAYMENT_METHOD'),
      field: 'friendly_name',
      sorter: 'string',
      headerFilter: 'input'
    },
    { title: t('CURRENCY'), field: 'currency', sorter: 'string', headerFilter: 'input' },
    {
      title: t('PERCENTAGE'),
      field: 'percentage',
      sorter: 'string',
      headerFilter: 'input',
      formatter: (cell: any) => `${cell.getValue()}%`
    },
    { title: t('BILLING_CODE'), field: 'billingCode', sorter: 'string', headerFilter: 'input' },
    { title: t('STATUS'), field: 'status', sorter: 'string', headerFilter: 'input' },
    {
      title: t('FULL_BILLING'),
      field: 'isFullBilling',
      sorter: 'string',
      headerFilter: 'input',
      formatter: (cell: any) => cell.getValue() ? t('NO') : t('YES')
    },
    {
      title: '',
      sortable: false,
      formatter: reactFormatter(<PaymentActions props={{
        downloadInvoice: downloadInvoice.bind(this),
        editPayments: editPayments.bind(this),
        deletePayments: deletePayments.bind(this),
        t: t
      }} />),
      headerSort: false,
      width: '300'
    }
  ];

  const columnsCreditNotes = [
    {
      title: t('DATE'), field: 'date', sorter: 'string', headerFilter: 'input',
      formatter: (cell: any) => {
        const locale = (window.navigator as any).userLanguage || window.navigator.language;
        return moment(cell.getValue()).locale(locale).format('DD/MM/YYYY HH:mm');
      }
    },
    { title: t('CREDIT_NOTE_CODE'), field: 'creditNoteCode', sorter: 'string', headerFilter: 'input' },
    { title: t('SUBTOTAL'), field: 'total', sorter: 'string', headerFilter: 'input' },
    { title: t('VAT'), field: 'vat', sorter: 'string', headerFilter: 'input' },
    {
      title: '',
      sortable: false,
      formatter: reactFormatter(<CreditNoteActions props={{
        editCreditNotes: editCreditNotes.bind(this),
        downloadCreditNote: downloadCreditNote.bind(this),
        t: t
      }} />),
      headerSort: false,
      width: '300'
    }
  ];

  const addPayment = (isFull?: boolean) => {
    if (isFull && payments && payments.length > 0) {
      const paymentData = {
        paymentTypeId: undefined,
        percentage: 100,
        deadlineDate: DateTime.now().plus({ days: 14 }).toJSDate(),
        isFullBilling: true,
        amount: order?.total,
        orderId: params.orderId,
        status: 'not_paid'
      };
      setLoading(true);
      authAxios.post(constants.api.addPayment, paymentData)
        .then(async () => {
          await checkPayments();
          paymentsTable.current?.reloadData();
          setLoading(false);
          message.success({
            content: t('PAYMENT_SAVED'),
            style: {
              marginTop: 100,
              zIndex: 1100
            }
          });
        }).catch(err => {
          setLoading(false);
          message.error({
            content: err?.response?.data?.errorMessage ? err?.response?.data?.errorMessage : err.message,
            style: {
              marginTop: 100,
              zIndex: 1100
            }
          });
        });
      return;
    }
    setShowInvoiceModal(true);
    setFull(isFull);
  };

  const addCreditNote = () => {
    setShowCreditModal(true);
  };



  return (<>
    {/* INVOICE MODAL */}
    <Modal show={showInvoceModal} onHide={() => setShowInvoiceModal(false)}
      backdrop='static' keyboard={false} size='xl' centered={true}>
      <Modal.Header closeButton>{t('ADD_PAYMENT')}</Modal.Header>
      <Modal.Body>
        <Container>
          <PaymentForm
            orderId={params.orderId}
            full={full}
            closeModal={async () => {
              setShowInvoiceModal(false);
              setRowData({});
              setFull(undefined);
              paymentsTable.current?.reloadData();
              await checkPayments();
            }}
            rowData={rowData}></PaymentForm>
        </Container>
      </Modal.Body>
    </Modal>

    {/* CREDIT NOTE MODAL */}
    <Modal show={showCreditNoteModal} onHide={() => setShowCreditModal(false)}
      backdrop='static' keyboard={false} size='xl' centered={true}>
      <Modal.Header closeButton>{t('ADD_CREDIT_NOTE')}</Modal.Header>
      <Modal.Body>
        <Container>
          <CreditNoteForm
            orderId={params.orderId}
            closeModal={async () => {
              setShowCreditModal(false);
              creditNotesTable.current?.reloadData();
              // await this.checkPayments();
            }}
          />
        </Container>
      </Modal.Body>
    </Modal>

    <Container fluid>
      <Button
        onClick={() => addPayment()}
        variant='primary'
        disabled={canAddPayment}
      >
        {t('ADD_PAYMENT')}
      </Button>
      <Button
        onClick={() => addPayment(true)}
        disabled={!canEmitFullInvoice}
        variant='primary'
        style={{ marginLeft: '1em' }}
      >
        {t('ADD_COMPLETE_PAYMENT')}
      </Button>
      <TableView
        t={t}
        ref={paymentsTable}
        id={'order_payments'}
        paginationSize={100}
        api={constants.api.getOrderPayments.replace('{orderId}', params.orderId)}
        columns={columnsPayments} />
    </Container>
    <Container fluid>
      <Button onClick={addCreditNote} variant='primary'>{t('ADD_CREDIT_NOTE')}</Button>
      <TableView
        t={t}
        ref={creditNotesTable}
        id={'order_credit_notes'}
        paginationSize={100}
        api={constants.api.getOrderCreditNotes.replace('{orderId}', params.orderId)}
        columns={columnsCreditNotes} />
    </Container>
    <Loader fullscreen={true} visible={loading} />
  </>);
};

export default Payments;